//External
import React, { useState, useEffect, useRef } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import Select from "react-select";
import { Navbar, Nav, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

//Internal
import falconWhiteImage from "../../public/assets/images/Falco_logo_icon_white.png";
import {
  getSelectLocationsOptions,
  get_cookie,
  locationOptions,
  set_cookie,
  hrefURL,
  setDefaultRedirectUrlUsingLocations,
  strToLowerCase,
  checkToken,
} from "../../utils";
import { logout } from "../../store/actions/auth";
import { getUserInfo } from "../../store/actions/user";
import {
  setShowDocumentHideProfile,
  setShowEditProfileHideShowProfile,
  setShowPaymentHideShowProfile,
  updateFilterClickCount,
  updateShareClickCount,
} from "../../store/actions";
import SearchBar from "components/search-bar";
import UserAvatar from "components/common/UserAvatar";
import DeleteUserModal from "components/modals/deleteUserModal";
import IconFilter from "components/icons/icons-filter";

// import { CDN_PATH } from "config";

// import locationIconUrl from "../../public/assets/images/mobile-ic/loaction-ic.svg";
// import locationIconUrlActive from "../../public/assets/images/mobile-ic/loaction-blue-ic.svg";

/*******************
  @Purpose :  used for header
  @Parameter : {brandList,currentLocationId,categoryList,currentPage,callUserInfo,headerDark,locations,...rest}
  @Author : INIC
  *******************/
function Header({
  brandList,
  currentLocationId,
  categoryList,
  currentPage,
  callUserInfo,
  headerDark,
  locations,
  headerWhite,
  ...rest
}) {
  const { setTabKey, addressInfo } = rest;
  const dispatch = useDispatch();
  const totalRecord = useSelector((state) => state?.common?.totalRecord);
  const cityStateSlug = get_cookie("cityStateSlug");
  const router = useRouter();
  const user = useSelector((state) => state?.user);
  const is_mobile_app = get_cookie("is_mobile_app");
  const [showHeader, setShowHeader] = useState(false);
  // Dropdown menu
  const [activeId, setActiveId] = useState("");
  const [closeMenu, setMenuClose] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [options, setOptions] = useState([]);
  const [optionsMobile, setOptionsMobile] = useState([]);
  const [defaultOptionValue, setDefaultOptionValue] = useState("0");
  const [defaultOptionValueMobile, setDefaultOptionValueMobile] = useState("0");
  const [locationName, setLocationName] = useState("Los Angeles");
  const [showModal, setShowModal] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [searchClosing, setSearchClosing] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const userMenuRef = useRef();
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  const mobileMakeSlug = "?screen_type=make_details&title=";

  /*******************
  @Purpose : toggle body overflow
  @Parameter : {}
  @Author : INIC
  *******************/
  useEffect(() => {
    document.body.classList.toggle("menu-open", isOpen);
  }, [isOpen]);

  /*******************
  @Purpose : Close user menu on outside click
  @Parameter : {}
  @Author : INIC
  *******************/
  useEffect(() => {
    if (!showUserMenu) return;
    const onDocClick = (e) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
        setShowUserMenu(false);
      }
    };
    document.addEventListener("click", onDocClick);
    return () => document.removeEventListener("click", onDocClick);
  }, [showUserMenu]);

  /*******************
  @Purpose : Close header search with exit animation
  @Parameter : {}
  @Author : INIC
  *******************/
  const closeHeaderSearch = () => {
    setSearchClosing(true);
    setTimeout(() => {
      setShowSearch(false);
      setSearchClosing(false);
    }, 220);
  };

  /*******************
  @Purpose : Lock body scroll and close on Escape while header search is open
  @Parameter : {}
  @Author : INIC
  *******************/
  useEffect(() => {
    document.body.classList.toggle("header-search-open", showSearch);
    if (!showSearch) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") closeHeaderSearch();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [showSearch]);

  // useEffect(() => {
  //   const footerElements = document.querySelectorAll(".footer-nav");
  //   footerElements.forEach((element) => {
  //     element.style.zIndex = "1039";
  //   });
  //   const headerElements = document.querySelectorAll(".header");
  //   headerElements.forEach((element) => {
  //     element.style.zIndex = "1041";
  //   });
  // }, [isOpen]);

  /*******************
  @Purpose : React Hook used for get user info
  @Parameter : {}
  @Author : INIC
  *******************/
  useEffect(() => {
    if (user?.token) {
      if (!user?.userInfo?.first_name) {
        // Check if user is a guest (new user)
        const isGuest = get_cookie("is_guest") === "true";

        // Only call profile API for existing users (not guests)
        if (!isGuest) {
          dispatch(getUserInfo(false));
        }
      }
    }
  }, [callUserInfo]);

  // set default redirect url
  setDefaultRedirectUrlUsingLocations(locations, currentLocationId);

  const [isWeb, setIsWeb] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.screen.width < 1024) {
      // device is mobile
      setIsWeb(false);
      setIsMobile(true);
    } else {
      // device is desktop
      setIsWeb(true);
      setIsMobile(false);
    }

    window.addEventListener("scroll", didScrollPage, 10);
    return () => {
      window.removeEventListener("keydown", didScrollPage);
    };
  }, []);

  /*******************
  @Purpose : get all locations
  @Parameter : {}
  @Author : INIC
  *******************/
  useEffect(() => {
    let tempOptions = locationOptions();
    let tempOptionsMobile = locationOptions();
    let tempDefaultOptionValue = "0";
    let tempDefaultOptionValue1 = "0";
    if (locations && locations.length !== 0) {
      // header for desktop
      tempOptions = [];
      const selectOptionsObj = getSelectLocationsOptions(
        locations,
        currentLocationId,
        "header"
      );
      tempDefaultOptionValue = selectOptionsObj.defaultOptionValue;
      tempOptions = selectOptionsObj.options;
      setOptions(tempOptions);
      setDefaultOptionValue(tempDefaultOptionValue);

      // footer for desktop
      tempOptionsMobile = [];
      const selectOptionsObj1 = getSelectLocationsOptions(
        locations,
        currentLocationId,
        "footer"
      );
      tempDefaultOptionValue1 = selectOptionsObj1.defaultOptionValue;
      tempOptionsMobile = selectOptionsObj1.options;
      setOptionsMobile(tempOptionsMobile);
      setDefaultOptionValueMobile(tempDefaultOptionValue1);
    }
  }, [locations]);

  /*******************
  @Purpose : used for scroll page
  @Parameter : {}
  @Author : INIC
  *******************/
  const didScrollPage = (e) => {
    const headerStickyOffset = 50;
    if (window.scrollY > headerStickyOffset) {
      setShowHeader(true);
      return "down";
    } else {
      setShowHeader(false);
      return "UP";
    }
  };

  /*******************
  @purpose : on location change event
  @Parameter : {slugname}
  @Author : INIC
  ******************/
  const onLocationChange = (slugName) => {
    let path = "";
    if (slugName == "/") {
      path = "/";
    } else {
      path = "/" + slugName;
    }
    set_cookie("redirectUrl", path);
    router.push(path);
  };

  /*******************
  @Purpose :used for home click redirect
  @Parameter : {}
  @Author : INIC
  *******************/
  const homeClickRedirect = () => {
    // const r = get_cookie("redirectUrl");
    let selectedCityName = "";
    if (get_cookie("selectedCityName")) {
      selectedCityName = get_cookie("selectedCityName");
    }

    const url = new URL(window.location.href);
    let r = "";
    if (url.pathname.includes("/fl/miami") || selectedCityName === "Miami") {
      r = "/fl/miami";
    } else {
      r = "/";
    }
    if (r) {
      router.push(r);
    } else {
      router.push("/");
    }
  };

  /*******************
  @Purpose :used for toggle active
  @Parameter : {}
  @Author : INIC
  *******************/
  function toggleActive(id) {
    if (activeId == id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  }

  /*******************
   @Purpose : Used to handle google logout
   @Parameter : {}
  @Author : INIC
  *******************/
  const onLogout = () => {
    dispatch(logout());
  };

  /*******************
   @Purpose : Used to handle logout
   @Parameter : {}
   @Author : INIC
  *******************/
  const handleLogout = () => {
    setMenuDefaultOptions();
    onLogout();
  };

  /*******************
   @Purpose : Used to DefaultOptions
   @Parameter : {}
   @Author : INIC
  *******************/
  const setMenuDefaultOptions = () => {
    if (window.screen.width < 1024) {
      setIsOpen(!isOpen);
    }
    setMenuClose(false);
    setShowOverlay(false);
    setActiveId(null);
  };

  /*******************
   @Purpose : Used to hideMobilemenubar
   @Parameter : {}
   @Author : INIC
  *******************/
  const hideMobileMenuBar = () => {
    setMenuClose(false);
    setShowOverlay(false);
    setIsOpen(!isOpen);
  };

  /*******************
   @Purpose : Used to common navigation
   @Parameter : {slug}
   @Author : INIC
  *******************/
  const commonNavigation = () => {
    if (window.screen.width < 1024) {
      setIsOpen(!isOpen);
    }
    setMenuClose(false);
    setShowOverlay(false);
    toggleActive("");
  };

  /*******************
   @Purpose : Brand divide in small part
   @Parameter : {brandList}
   @Author : INIC
  *******************/
  const makeBrandOrCategoryList = (brandList1) => {
    let finalData = [];
    let sliceValue = 5;
    let loopValue = Math.ceil(brandList1.length / sliceValue);
    for (let i = 0; i < loopValue; i++) {
      let startValue = i * sliceValue;
      let endValue = startValue + sliceValue;
      let sliceData = brandList1
        .slice(startValue, endValue)
        .map((data, index) => {
          return (
            <Link
              href={hrefURL(
                data.slug +
                (is_mobile_app === "yes" ? mobileMakeSlug + data?.title : "")
              )}
              key={index}
            >
              <a onClick={() => setMenuDefaultOptions()} title={data.title}>
                {data.title}
              </a>
            </Link>
          );
        });
      finalData.push(
        <li className="dropdown-items" key={i}>
          {sliceData}
        </li>
      );
    }
    return finalData;
  };

  /*******************
   @Purpose : Update filter click on mobile view for brand or category
   @Parameter : {}
   @Author : INIC
  *******************/
  const updateFilterClick = () => {
    dispatch(updateFilterClickCount(1));
  };

  /*******************
   @Purpose : Update share click on mobile view for vehicle page
   @Parameter : {}
   @Author : INIC
  *******************/
  const updateShareClick = () => {
    dispatch(updateShareClickCount(1));
  };

  /*******************
   @Purpose : Set location name in mobile using cookie slug
   @Parameter : {}
   @Author : INIC
  *******************/
  useEffect(() => {
    if (get_cookie("cityStateSlug")) {
      const exArr = get_cookie("cityStateSlug").split("_");
      const cityName = strToLowerCase(exArr[0]);
      const stateName = strToLowerCase(exArr[1]);
      let lName = "";
      locations?.forEach(function (location) {
        const stateShortName = strToLowerCase(location?.state_short_name);
        const cityShortName = strToLowerCase(location?.city_short_name);
        if (stateName === stateShortName && cityName === cityShortName) {
          lName = location?.city_name;
        }
      });
      if (lName) {
        setLocationName(lName);
      }
    }
  }, [locations, get_cookie("cityStateSlug")]);

  /*******************
   @Purpose : Menu handler
   @Parameter : {}
   @Author : INIC
  *******************/
  const locationRef = useRef();
  const menuOpenHandler = () => {
    if (locationRef.current) {
      locationRef.current.focus();
    }
  };

  const [telNoStr, setTelNoStr] = useState("");
  const [companyPhoneNo, setCompanyPhoneNo] = useState("");

  useEffect(() => {
    setTimeout(() => {
      setTelNoStr("tel:" + addressInfo?.company_phone);
      setCompanyPhoneNo(addressInfo?.company_phone);
    }, 3000);
  }, [addressInfo]);

  // useLayoutEffect(() => {
  //   const scriptId = "newra-widget-script";

  //   // Function to add the script
  //   const addScript = () => {
  //     if (!document.getElementById(scriptId)) {
  //       const script = document.createElement("script");
  //       script.id = scriptId;
  //       script.src = CHATBOT_URL;
  //       script.async = true;
  //       document.body.appendChild(script);
  //     }
  //   };

  //   // Function to remove the script and ALL related elements
  //   const removeScript = () => {
  //     // First, check for any global variables or functions the script might have added
  //     if (window.newraWidget || window.newra) {
  //       // If the widget has a destroy or cleanup method, call it
  //       if (typeof window.newraWidget?.destroy === 'function') {
  //         window.newraWidget.destroy();
  //       }
  //       if (typeof window.newra?.destroy === 'function') {
  //         window.newra.destroy();
  //       }

  //       // Try to remove any global references
  //       try {
  //         delete window.newraWidget;
  //         delete window.newra;
  //       } catch (e) {
  //         console.error("Error removing global references:", e);
  //       }
  //     }

  //     // Remove the script tag
  //     const existingScript = document.getElementById(scriptId);
  //     if (existingScript) {
  //       existingScript.parentNode.removeChild(existingScript);
  //     }

  //     // Find and remove ALL elements that might be related to the Newra widget
  //     // This is more aggressive but necessary if the widget is persisting
  //     const selectors = [
  //       '[id^="newra-"]',
  //       '[class^="newra-"]',
  //       '[id*="newra"]',
  //       '[class*="newra"]',
  //       // Add more specific selectors if you know what elements the widget creates
  //       '#newra-widget',
  //       '#newra-chat',
  //       '.newra-container'
  //     ];

  //     selectors.forEach(selector => {
  //       document.querySelectorAll(selector).forEach(el => {
  //         if (el && el.parentNode) {
  //           el.parentNode.removeChild(el);
  //         }
  //       });
  //     });
  //   };

  //   const shouldShowWidget = ALLOWED_PAGES.includes(currentPage) &&
  //     isWeb;

  //   if (shouldShowWidget) {
  //     addScript();
  //   } else {
  //     removeScript();
  //   }

  //   // Always clean up when unmounting or when dependencies change
  //   return () => {
  //     if (!shouldShowWidget) {
  //       removeScript();
  //     }
  //   };
  // }, [isWeb, currentPage]);

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      <header
        className={`header hasTheBot ${showHeader ? "sticky" : ""} ${headerDark ? "header-dark" : ""
          } ${currentPage == "404" ? "bg-black box-shadow-none border-0" : ""}
        ${headerWhite ? "sticky" : ""}
        `}
      >
        <div className="custom-container">
          <Navbar>
            <div onClick={homeClickRedirect} className="header-logo">
              <Navbar.Brand className="p-0">
                <div className="logo-img">
                  {/* <div className="img-wrap"> */}
                  <img
                    // src={CDN_PATH + "/logo.png"}
                    src={falconWhiteImage}
                    height={40}
                    width={110}
                    objectFit="contain"
                    title="Falcon car rental"
                    alt="Falcon car rental"
                  />
                  {/* </div> */}
                </div>
              </Navbar.Brand>
            </div>

            <div className="header-left">
              {is_mobile_app !== "yes" && (
                <div
                  className="navbar-toggler d-block d-tab-none"
                  onClick={function (event) {
                    setMenuClose(true);
                    setShowOverlay(true);
                    setIsOpen(!isOpen);
                  }}
                >
                  <span className="nav-line"></span>
                </div>
              )}
              <div
                className={showOverlay ? "overlay active" : "overlay"}
                onClick={function (event) {
                  setMenuClose(false);
                  setShowOverlay(false);
                  setIsOpen(!isOpen);
                }}
              ></div>
              <Navbar.Collapse
                id="basic-navbar-nav"
                className={`pr-0 ${closeMenu ? "show" : ""}`}
              >
                <div className="d-flex flex-column w-100">
                  <span
                    className="icon icon-close d-inline-block d-tab-none"
                    onClick={function (event) {
                      setMenuClose(false);
                      setShowOverlay(false);
                      setIsOpen(!isOpen);
                    }}
                  ></span>

                  <Nav className="mr-auto">
                    {user?.userInfo?.first_name &&
                      checkToken() &&
                      get_cookie("is_guest") !== "true" && (
                        <Link href="/personal-details">
                          <div
                            className="d-flex d-tab-none align-content-between align-items-center nav-link user-details"
                            onClick={() => {
                              hideMobileMenuBar();
                              if (setTabKey) setTabKey("personalInfo");
                            }}
                          >
                            <UserAvatar userInfo={user?.userInfo} />
                            <span className="text-truncate ml-10 ff-hel-med text-black text-capitalize">
                              {user?.userInfo?.first_name}{" "}
                              {user?.userInfo?.last_name
                                ? user?.userInfo?.last_name["0"] + "."
                                : ""}
                            </span>
                          </div>
                        </Link>
                      )}
                    <div className="nav-link cursor-pointer location-nav-link">
                      <div
                        className={
                          activeId == 4
                            ? "d-flex align-items-center justify-content-between nav-title active"
                            : "d-flex align-items-center justify-content-between nav-title"
                        }
                        onClick={() => toggleActive(4)}
                      >
                        {locationName}
                        <span className="icon icon-down-caret"></span>
                      </div>
                      <ul
                        className={
                          activeId == 4
                            ? "list-unstyled mb-0 nav-menu custom-dropdown location-dropdown active"
                            : "list-unstyled mb-0 nav-menu custom-dropdown location-dropdown"
                        }
                      >
                        <li className="dropdown-items" key="12">
                          {locations &&
                            locations?.map((row, index) => (
                              <Link
                                href={
                                  index > 0
                                    ? strToLowerCase(row.state_short_name) +
                                    "/" +
                                    row.city_slug
                                    : "/"
                                }
                                key={index}
                              >
                                <a
                                  title={row.city_name}
                                  onClick={() => commonNavigation()}
                                >
                                  {row.city_name}
                                </a>
                              </Link>
                            ))}
                        </li>
                      </ul>
                    </div>
                    <div className="nav-link cursor-pointer">
                      <div
                        className={
                          activeId == 1
                            ? "d-flex align-items-center justify-content-between nav-title active"
                            : "d-flex align-items-center justify-content-between nav-title"
                        }
                        onClick={() => toggleActive(1)}
                      >
                        Makes <span className="icon icon-down-caret"></span>
                      </div>

                      <ul
                        className={
                          activeId == 1
                            ? "list-unstyled mb-0 nav-menu custom-dropdown active"
                            : "list-unstyled mb-0 nav-menu custom-dropdown"
                        }
                      >
                        {brandList && makeBrandOrCategoryList(brandList)}
                      </ul>
                    </div>
                    <div className="nav-link cursor-pointer">
                      <div
                        className={
                          activeId == 2
                            ? "d-flex align-items-center justify-content-between nav-title active"
                            : "d-flex align-items-center justify-content-between nav-title"
                        }
                        onClick={() => toggleActive(2)}
                      >
                        Categories{" "}
                        <span className="icon icon-down-caret"></span>
                      </div>
                      <ul
                        className={
                          activeId == 2
                            ? "list-unstyled mb-0 nav-menu custom-dropdown active"
                            : "list-unstyled mb-0 nav-menu custom-dropdown"
                        }
                      >
                        {categoryList && makeBrandOrCategoryList(categoryList)}
                      </ul>
                    </div>

                    {user.token ? (
                      <div className="nav-link cursor-pointer d-block d-tab-none">
                        <Link href={"/wishlists"}>
                          <a
                            title="Wishlist"
                            className="text-black"
                            onClick={() => commonNavigation()}
                          >
                            Wishlist
                          </a>
                        </Link>
                      </div>
                    ) : (
                      ""
                    )}
                    {/* {user.token ? (
                      <div className="nav-link cursor-pointer d-block d-tab-none">
                        <div
                          className="nav-title logout"
                          onClick={() => handleShow()}
                        >
                          Delete Account
                        </div>
                      </div>
                    ) : (
                      ""
                    )} */}
                    {user.token ? (
                      <div className="nav-link cursor-pointer d-block d-tab-none logout-nav">
                        <div
                          className="nav-title"
                          onClick={() => handleLogout()}
                        >
                          Logout
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </Nav>
                </div>
                <div className="w-100 d-block d-tab-none mobile-menu-bottom">
                  {companyPhoneNo && (
                    <a
                      href={telNoStr}
                      className="btn btn-gray w-100 font-16 mb-10"
                    >
                      <div className="d-flex justify-content-center align-content-center">
                        <span className="icon icon-phone-call font-20"></span>
                        {companyPhoneNo}
                      </div>
                    </a>
                  )}

                  {user.token ? (
                    ""
                  ) : (
                    // <Link href="/login">
                    <Button
                      variant="primary"
                      className="text-uppercase w-100 font-14 mb-10"
                      onClick={() => router.push("/login")}
                    >
                      Log in / Sign up
                    </Button>
                    // </Link>
                  )}

                </div>
              </Navbar.Collapse>

              {/* Right content : Start */}
              <ul className="d-flex justify-content-center align-items-center list-unstyled mb-0 header-right">
                <li className={`search-slot ${showSearch ? "searching" : ""}`}>
                  <span
                    className="search-icon"
                    onClick={() => setShowSearch(true)}
                  ></span>
                </li>
                <li>
                  <div className="user-login">
                    {/* After Login */}
                    {user.userInfo &&
                      user?.token &&
                      checkToken() &&
                      get_cookie("is_guest") !== "true" ? (
                      <div
                        className={`user-dropdown position-relative ${
                          showUserMenu ? "open" : ""
                        }`}
                        ref={userMenuRef}
                      >
                        <div
                          className="d-flex align-content-between align-items-center user-details"
                          onClick={() => setShowUserMenu(!showUserMenu)}
                        >
                          <UserAvatar userInfo={user?.userInfo} />
                        </div>

                        <ul
                          className="list-unstyled mb-0 custom-dropdown user-menu"
                          onClick={() => setShowUserMenu(false)}
                        >
                          <li
                            className="dropdown-items"
                            onClick={() => {
                              if (user?.userInfo?.profile_completed) {
                                dispatch(
                                  setShowEditProfileHideShowProfile(true)
                                );
                                dispatch(setShowDocumentHideProfile(true));
                                dispatch(setShowPaymentHideShowProfile(true));
                              }
                            }}
                          >
                            <Link href="/personal-details">Profile</Link>
                          </li>
                          <li className="dropdown-items">
                            <Link href={"/my-trips"}>My Trips</Link>
                          </li>
                          <li className="dropdown-items">
                            <Link href={"/wishlists"}>Wishlist</Link>
                          </li>
                          <li
                            className="dropdown-items"
                            onClick={() => {
                              dispatch(setShowEditProfileHideShowProfile(1));
                              dispatch(setShowDocumentHideProfile(false));
                              dispatch(setShowPaymentHideShowProfile(true));
                            }}
                          >
                            <Link href="/personal-details?desk=doc">
                              Documents
                            </Link>
                          </li>
                          <li
                            className="dropdown-items"
                            onClick={() => {
                              dispatch(setShowEditProfileHideShowProfile(true));
                              dispatch(setShowDocumentHideProfile(true));
                              dispatch(setShowPaymentHideShowProfile(false));
                            }}
                          >
                            <Link href="/personal-details?desk=payment">
                              Payment
                            </Link>
                          </li>
                          {/* <li className="dropdown-items">
                            <a
                              onClick={() => handleShow()}
                              className="text-danger"
                            >
                              Delete Account
                            </a>
                          </li> */}
                          <li className="dropdown-items">
                            <a onClick={() => handleLogout()}>Logout</a>
                          </li>
                        </ul>
                      </div>
                    ) : (
                      <div
                        className="d-flex align-items-center cursor-pointer user-link"
                        onClick={() => router.push("/login")}
                      >
                        <span className="profile-icon"></span>
                      </div>
                    )}
                  </div>
                </li>
                {/* Right content : End */}
              </ul>
            </div>

            {/* Header search : Start */}
            {showSearch && (
              <>
                <div
                  className={`search-backdrop ${
                    searchClosing ? "closing" : ""
                  }`}
                  onClick={() => closeHeaderSearch()}
                ></div>
                <div
                  className={`header-search-field ${
                    searchClosing ? "closing" : ""
                  }`}
                >
                  <SearchBar
                    currentLocationId={currentLocationId}
                    showMenu={showSearch}
                    setShowMenu={closeHeaderSearch}
                    showAutofocus={true}
                  />
                </div>
              </>
            )}
            {/* Header search : End */}

            {/* Filter icon for brand and category page start here */}
            {(currentPage == "brand" || currentPage == "category") &&
              totalRecord > 6 && (
                <div
                  className="mobile-phone d-inline-block d-tab-none"
                  onClick={() => updateFilterClick()}
                >
                  <IconFilter className="icon" />
                </div>
              )}
            {(((currentPage === "brand" || currentPage === "category") &&
              totalRecord <= 6) ||
              ![
                "home",
                "dynamic",
                "blog",
                "cms",
                "contact-us",
                "faqs",
                "tripDetail",
                "vehicle",
                "brand",
                "category",
              ].includes(currentPage)) && <div className="empty-box"></div>}

            {/* Filter icon for brand and category page end here */}

            {/* phone icon for home page and serving pages start here */}
            {(currentPage == "home" ||
              currentPage == "dynamic" ||
              currentPage == "blog" ||
              currentPage == "cms" ||
              currentPage == "contact-us" ||
              currentPage == "faqs" ||
              currentPage == "tripDetail") &&
              // <div className="mobile-phone d-inline-block d-tab-none">
              //   <Link href="tel:+1-310-887-7005">
              //     <span className="icon icon-phone"></span>
              //   </Link>
              // </div>
              is_mobile_app !== "yes" && (
                <div className="d-flex align-items-center gap-1">
                  <div
                    className="city-dropdown d-flex align-items-center justify-content-start flex-column h-100 select-link d-tab-none"
                  // onClick={() => menuOpenHandler()}
                  >
                    <span
                      className="icon icon-location"
                      onClick={() => menuOpenHandler()}
                    ></span>

                    {/* <img src={locationIconUrl}></img> */}
                    {/* <span className="icon loc-ic ic-2">
                  <img src={locationIconUrlActive}></img>
                </span> */}
                    <Select
                      ref={locationRef}
                      instanceId="location"
                      menuPlacement="auto"
                      isSearchable={false}
                      value={optionsMobile[defaultOptionValueMobile]}
                      classNamePrefix="custom_link"
                      options={optionsMobile}
                      onChange={(e) => {
                        onLocationChange(e.value);
                      }}
                      openMenuOnFocus={true}
                    />
                  </div>
                </div>
              )}
            {/* phone icon for home page and serving pages start here */}

            {/* share icon for vehicle page start here */}
            {currentPage == "vehicle" && (
              <div
                className="d-block d-sm-none"
                onClick={() => updateShareClick()}
              >
                <span className="icon icon-export"></span>
              </div>
            )}
            {/* share icon for vehicle page end here */}
          </Navbar>
        </div>
        <DeleteUserModal
          showHandler={showModal}
          hideHandler={handleClose}
          modalTitle="Delete your account"
        />
      </header>
    </>
  );
}

export default Header;
